// extracted by mini-css-extract-plugin
export default {"totalElementCount":"TotalElementCount_totalElementCount__VctmG","inside":"TotalElementCount_inside__JP35P"};